/** The office trip page gives each tab its own route, `/trips/:id/<tab>` (`recordTabRoutes`). */
export const TRIP_TABS = [
  'overview',
  'timeline',
  'events',
  'messages',
  'expenses',
  'accessorials',
  'cash',
  'record',
  'alerts',
  'exceptions',
  'documents',
  'history',
] as const;
export type TripTab = (typeof TRIP_TABS)[number];

export const TRIP_TAB_LABELS: Record<TripTab, string> = {
  overview: 'Overview',
  timeline: 'Timeline',
  events: 'Events',
  messages: 'Messages',
  expenses: 'Expenses',
  accessorials: 'Accessorials',
  cash: 'Cash',
  record: 'Record for driver',
  alerts: 'Alerts',
  exceptions: 'Exceptions',
  documents: 'Documents',
  history: 'History',
};

export const tripPaths = {
  /** The bare path redirects to the first tab. */
  trip: (tripId: string) => `/trips/${tripId}`,
  tripTab: (tripId: string, tab: TripTab) => `/trips/${tripId}/${tab}`,
} as const;
